module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('items-list', {
    staticClass: "nav-container",
    attrs: {
      "items": _vm.items,
      "level": 1,
      "max-level": _vm.maxLevel,
      "small": _vm.small,
      "compact": false
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e00715f","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/Mobile.vue
// module id = c33180a8d70b8b5abd62
// module chunks = 8